export default class FileUser {
    id!: number;
    key!: string;
    typeOfDocument!: string;
    url!: string;
}
